// extracted by mini-css-extract-plugin
export default {"section":"section__e14e0a5b"};